import Tone from 'tone';

const name = 'QmcdpaZe62u6p47s2Nmi7jYLpgTbmz6MxVnwvndNFi53Sf'; //convolver/PrimeXtraLong.wav';

class SampleRateChooser {
    constructor() {
        this.DEFAULT_BUFFER = new Tone.Buffer(window.isNFT ? name : '/ipfs/' + name);
        console.log("SAMPLE RATE CHOOSER called and name=", name);
    }

    updateBuffer() {
        this.DEFAULT_BUFFER = new Tone.Buffer(window.isNFT ? name : '/ipfs/' + name);
    }

    setSampleRate(rate, latencyHint='interactive') {
        console.log('setting sample rate=', rate);
	if (rate === Tone.context.sampleRate) {
            console.log('it was already that so we dont need to');
	    return;
	}
        Tone.setContext(new AudioContext({
            sampleRate: rate,
            latencyHint: 'playback'
        }));
        window.context = Tone.Master.context;
        this.DEFAULT_BUFFER = new Tone.Buffer(window.isNFT ? name : '/ipfs/' + name);
    }
}

const sampleRateChooser = new SampleRateChooser();
export default sampleRateChooser;
